<template>
  <div class="h-full pb-8 pt-0 w-full">
    <Products :storeId="this.$route.params.storeId" />
  </div>
</template>

<script>
import Products from '@/pages/Products.vue'

export default {
  name: 'homeComponent',
  components: { Products },
  data() {
    return {}
  },
  beforeUnmount() {},
  mounted() {},
  methods: {},
}
</script>
